// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4792":"f045f57ce2f106d31c12","7992":"f045f57ce2f106d31c12"}[chunkId] + ".chunk.css";
};